import FavouriteFilled from '@ori-ui/icons/lib/FavouriteFilled';
import FavouriteOutlined from '@ori-ui/icons/lib/FavouriteOutlined';
import { jsx as _jsx } from "react/jsx-runtime";
const MuiRating = {
  icon: /*#__PURE__*/_jsx(FavouriteFilled, {}),
  emptyIcon: /*#__PURE__*/_jsx(FavouriteOutlined, {})
};
export default MuiRating;